import { indexedDBLocalPersistence } from 'firebase/auth';

export default indexedDBLocalPersistence;
